import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { WidgetErrorTypeEnum } from '../../models/widget-error-type.enum';
import { WidgetErrorModel } from '../../models/widget-error.model';
import { defaultContentErrorConfig } from '../../data/content-error-config';
import { authErrorConfig, defaultAuthErrorConfig } from '../../data/auth-error-config';
import { webGLErrorConfig, defaultWebGLErrorConfig } from '../../data/webgl-error-config';
import { get } from 'lodash';

// generic error messaging
const defaultErrorConfig: WidgetErrorModel = {
  title: `We're unable to find the page you're looking for.`,
  description: `Please check your URL or return to our <a href="/">homepage</a>.`
};

@Component({
  selector: 'app-widget-error',
  templateUrl: './widget-error.component.html',
  styleUrls: ['./widget-error.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WidgetErrorComponent implements OnInit {
  errorTypeEnum = WidgetErrorTypeEnum;
  supportURL = 'https://support.biodigital.com';

  errorType: WidgetErrorTypeEnum = WidgetErrorTypeEnum.Content;
  errorCode: string;

  get widgetError(): WidgetErrorModel {
    let config: WidgetErrorModel;

    // get custom error config based on error type + error code (i.e., specific auth issues)
    switch (this.errorType) {
      case WidgetErrorTypeEnum.Auth:
        config = authErrorConfig[this.errorCode] || defaultAuthErrorConfig;
        break;
      case WidgetErrorTypeEnum.Engine:
        config = webGLErrorConfig[this.errorCode] || defaultWebGLErrorConfig;
        break;
      case WidgetErrorTypeEnum.Content:
        config = defaultContentErrorConfig;
        break;
      default:
        config = defaultErrorConfig;
        break;
    }

    return config;
  }

  get title(): string {
    return get(this.widgetError, 'title', defaultErrorConfig.title);
  }

  get description(): string {
    return get(this.widgetError, 'description', defaultErrorConfig.description);
  }

  get url(): string {
    return get(this.widgetError, 'url', defaultErrorConfig.url);
  }

  constructor(
    private route: ActivatedRoute,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.initErrorHandling();
  }

  initErrorHandling() {
    const { errorType, errorCode } = this.route.snapshot.queryParams;
    this.errorType = errorType;
    this.errorCode = errorCode;
  }

  handleActionClick(url: string) {
    // launch URL in new window
    const targetWindow = window.open(url);
    if (!targetWindow) { // notify user if blocked      
      this.snackBar.open('Unable to open link in new window, please check your pop-up settings.');
    }
  }

}
